/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { AREC_ORGANIZATION_IDS } from '@config/constants/organizations';
import useStore from '@store/index';
import { useNavigate } from 'react-router';

/* -------------------------------------------------------------------------- */
/*                                  Hook                                      */
/* -------------------------------------------------------------------------- */
export const useLogout = () => {
	const { getUser } = useStore();
	const navigate = useNavigate();
	const user = getUser();

	return () => {
		localStorage.removeItem('user');

		if (
			Object.values(AREC_ORGANIZATION_IDS).includes(
				user?.organization?.id
			)
		) {
			navigate('/arec/login');
		} else {
			navigate('/login');
		}
	};
};
